var _style, _path, _path2, _path3, _path4, _polygon, _polygon2, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon3, _polygon4, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUfanLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 246.2",
    style: {
      enableBackground: "new 0 0 595.3 246.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E26B0E;}\n\t.st3{fill:url(#SVGID_00000094592963635535636000000013659579227523523989_);}\n\t.st4{fill:#3D93D0;}\n\t.st5{fill:#392A71;}\n\t.st6{fill:url(#SVGID_00000101078960563272528590000001350361026280973964_);}\n\t.st7{fill:url(#SVGID_00000042001747873930979090000016136716029358113687_);}\n\t.st8{fill:url(#SVGID_00000180342983340047511290000008702739006087032722_);}\n\t.st9{fill:#E6F3F2;}\n\t.st10{fill:#FFF186;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.7262,
    y1: -62.9094,
    x2: 414.7041,
    y2: 295.5868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#26305F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01955307,
    style: {
      stopColor: "#48328A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    style: {
      stopColor: "#26305F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.1,206.7c13.7,11.7,33.8,16.7,51.6,16.7c2.1,0,4.1-0.1,6.2-0.3c14-1.1,27.1-6.1,38.2-14.2l0.1,14.5h67.3 v-25.6h11.2l-5.1,25.6h180.2l-2.1-38.5l25.2,38.5h100.8l29.7-182.3c-32.8,6.4-87.2,11.6-121.8,13.9v23.3l-10.8-22.6 c-31.6,2.1-71.1,3.5-138.7,4c-53.6,0.4-173.5-6-186.7-7.3c0,0,0,0,0,0c-0.8-0.1-1.2-0.2-1.2-0.2l7.7,90.6c0.3,3.4-2.2,6.3-5.6,6.6 c-3.4,0.3-6.3-2.2-6.6-5.6l-7.8-92.5c0,0-18.1-2.2-28.6-3.6c-0.9-0.1-1.8-0.2-2.6-0.4c-0.7-0.1-1.4-0.2-2-0.3 c-1.4-0.2-3.4-0.5-5.7-0.8c-1.1-0.1-2.2-0.3-3.5-0.5c-0.3,0-0.5-0.1-0.8-0.1c-0.7-0.1-1.5-0.2-2.2-0.3c-0.3,0-0.6-0.1-0.9-0.1 c-0.8-0.1-1.5-0.2-2.3-0.3c-11-1.5-23-3.1-23-3.1c0,0,12.2,93.2,14.7,112.6C43.5,174.4,50.9,193.8,66.1,206.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M541.3,225.5H437.8l-21.7-33.2l1.8,33.2H233.2l5.1-25.6h-6.8v25.6h-71.3l-0.1-12.7 c-10.7,7.1-23.1,11.3-36.1,12.4c-2.1,0.2-4.3,0.3-6.4,0.3c-20.5,0-40.2-6.4-52.9-17.2C50.9,196.4,42,178,38.9,154.8 C36.5,136.3,25.3,50.5,24.3,42.7l-0.4-3.1l3.1,0.4c2.4,0.3,12.9,1.7,22.5,3.1l9.7,1.3c2.3,0.3,4.3,0.6,5.7,0.8 c0.6,0.1,1.3,0.2,2,0.3l2.6,0.4c10.4,1.4,28.4,3.6,28.6,3.6l1.6,0.2l8,94.1c0.1,1.1,0.6,2.1,1.5,2.9c0.8,0.7,1.9,1,3,1 c1.1-0.1,2.1-0.6,2.8-1.4c0.7-0.8,1.1-1.9,1-3L107.9,50l2.5,0.4c0,0,0.4,0.1,1.2,0.2c13.8,1.4,132.9,7.6,186.4,7.3 c62.1-0.4,103.5-1.6,138.6-4l1.3-0.1l7.6,15.9V53.2l1.9-0.1c38.2-2.5,90.6-7.8,121.6-13.9l2.8-0.5L541.3,225.5z M439.9,221.5h98 l28.9-177.8c-30.9,5.8-80.4,10.8-117.4,13.3v30.2l-14-29.2c-34.8,2.3-76.1,3.5-137.5,3.9c-52.4,0.3-167.3-5.6-185.7-7.2l7.5,88.2 c0.2,2.2-0.5,4.3-1.9,5.9c-1.4,1.6-3.4,2.7-5.5,2.8c-2.1,0.2-4.2-0.5-5.9-1.9c-1.7-1.4-2.7-3.4-2.8-5.6L96,53.2 c-4.7-0.6-18.4-2.3-27-3.4l-2.6-0.4c-0.7-0.1-1.4-0.2-2-0.3c-1.4-0.2-3.4-0.5-5.7-0.8L48.9,47c-7.9-1.1-16.3-2.2-20.4-2.8 c2,15.2,12.1,92.6,14.4,110.1c2.9,22.1,11.4,39.7,24.5,50.9l0,0c11.9,10.2,30.7,16.3,50.3,16.3c2,0,4.1-0.1,6.1-0.2 c13.5-1.1,26.4-5.9,37.2-13.8l3.1-2.3l0.1,16.4h63.3v-25.6h15.6l-5.1,25.6h175.7l-2.4-43.8L439.9,221.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.3,208.1c-9.8,0.3-19.6,0.7-29.2,1.1l-4.7-130.5c30.1,1.4,63.1,1.5,94.8,1.5c2.9,0,3,0,5.9,0l-7.2,29.2 l-62.3-1.4v12.4l60-1.5l-8,31.9l-52-1.4L215.3,208.1z M326.6,207.9l-1.2-20.6l-26.8-0.7l-6.2,23c-9.2-0.1-18.5-0.2-27.9-0.2 c-2.9,0-5.7,0-8.6,0l33.2-129.3c19.5-0.2,37.8-0.7,56.6-1.4l16.3,130.5C350.4,208.7,338.6,208.2,326.6,207.9z M481.2,208.6 c-1,0-29.5,0.7-29.5,0.7l-57.1-104.7l3.7,104.1c0,0-19.1-0.2-28.4,0L354.2,78.7c23.9-1.2,48.6,0.4,71.1-1.6l30.2,78.4l4.5-78.2 c12.7-1.4,27-2.9,39.1-4.6L481.2,208.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135687081434996109480000018034053303334035877_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.5562,
    y1: 251.0301,
    x2: 404.7636,
    y2: 13.3798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59D0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEC2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135687081434996109480000018034053303334035877_)"
    },
    d: "M216.2,203.4c-9.8,0.3-19.6,0.7-29.2,1.1 l-4.7-130.5c30.1,1.4,63.1,1.5,94.8,1.5c2.9,0,3,0,5.9,0l-7.2,29.2l-62.3-1.4v12.4l60-1.5l-8,31.9l-52-1.4L216.2,203.4z  M327.5,203.2l-1.2-20.6l-26.8-0.7l-6.2,23c-9.2-0.1-18.5-0.2-27.9-0.2c-2.9,0-5.7,0-8.6,0l33.2-129.3c19.5-0.2,37.9,0.3,56.8-0.4 L363,204.6C351.3,204,339.5,203.6,327.5,203.2z M482.1,203.9c-1,0-29.5,0.7-29.5,0.7L395.5,99.8l3.7,104.1c0,0-19.1-0.2-28.4,0 L355.2,75c27,0,46.8,0.2,71.8-0.9l29.5,76.8l4.5-78.1c7.5-0.5,29.9-3.1,39.1-4.3L482.1,203.9z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.3,78.4c-11.8-0.6-23.4-1.4-34.8-2.2l5.9,69.8c1.1,13.6-9,25.6-22.6,26.7h0c-13.6,1.1-25.6-9-26.7-22.6 l-6.3-75.2c-0.1-1.2-0.1-3.1-0.3-5c-11.7-1.2-22.9-2.5-34.2-3.9c2.8,26.1,7.7,72.2,9.5,91.5c2.9,31.1,29.9,54.4,61,51.8l0,0 c31.2-2.5,54.4-29.9,51.8-61C168.6,148.3,166.9,111.8,165.3,78.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "305.2,153.1 323.7,153.1 318.4,94.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027606842929793559310000015921691055796653214_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.7164,
    y1: 59.9019,
    x2: 164.1172,
    y2: 176.3027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1899,
    style: {
      stopColor: "#BADFDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    style: {
      stopColor: "#9FD1DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4769,
    style: {
      stopColor: "#81C1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6446,
    style: {
      stopColor: "#68B7D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8167,
    style: {
      stopColor: "#57B0D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50AED5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027606842929793559310000015921691055796653214_)"
    },
    d: "M165.3,73.7c-11.8-0.6-23.4-1.4-34.8-2.2 l5.9,69.8c1.1,13.6-9,25.6-22.6,26.7h0c-13.6,1.1-25.6-9-26.7-22.6l-6.3-75.2c-0.1-1.2-0.1-3.1-0.3-5c-11.7-1.2-22.9-2.5-34.2-3.9 c2.8,26.1,7.7,72.2,9.5,91.5c2.9,31.1,29.9,54.4,61,51.8l0,0c31.2-2.5,54.4-29.9,51.8-61C168.6,143.6,166.9,107.2,165.3,73.7z"
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "512.6,69.7 501.2,175.3 525.7,176.2 547,65.4 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 510.5,
    cy: 196,
    r: 14.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034066059605161166190000008621491017043588503_",
    gradientUnits: "userSpaceOnUse",
    x1: 907.7521,
    y1: 403.1976,
    x2: 917.634,
    y2: 513.5286,
    gradientTransform: "matrix(0.996 8.920819e-02 -8.920819e-02 0.996 -340.3351 -419.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BADFDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1298,
    style: {
      stopColor: "#9FD1DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3028,
    style: {
      stopColor: "#81C1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4797,
    style: {
      stopColor: "#68B7D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6613,
    style: {
      stopColor: "#57B0D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#50AED5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000034066059605161166190000008621491017043588503_)"
    },
    points: "516.3,66.9 504.9,172.5  529.4,173.4 550.8,62.6 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076580403467471729530000010832392698293823890_",
    gradientUnits: "userSpaceOnUse",
    x1: 903.8501,
    y1: 522.0444,
    x2: 906.4352,
    y2: 550.9079,
    gradientTransform: "matrix(0.996 8.920819e-02 -8.920819e-02 0.996 -340.3351 -419.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2067,
    style: {
      stopColor: "#BADFDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#9FD1DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4877,
    style: {
      stopColor: "#81C1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    style: {
      stopColor: "#68B7D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8205,
    style: {
      stopColor: "#57B0D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50AED5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000076580403467471729530000010832392698293823890_)"
    },
    cx: 513.3,
    cy: 195.1,
    r: 14.5
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M498.9,195.8c0.7-8,7.8-13.9,15.7-13.1c7.2,0.6,12.7,6.5,13.1,13.5c0.6-7.9-5.3-14.8-13.1-15.5 c-8-0.7-15,5.2-15.7,13.1c-0.1,0.8-0.1,1.5,0,2.3C498.9,196,498.9,195.9,498.9,195.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M80.8,70.2c-0.1-1.2-0.1-3.1-0.3-5c-11.7-1.2-22.9-2.5-34.2-3.9c0.2,1.7,0.4,3.5,0.6,5.4 c6.6,0.8,19.2,2.3,34,3.9L80.8,70.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.3,73.7c-11.8-0.6-23.4-1.4-34.8-2.2l0.4,4.2c14.8,1.4,27.6,2.6,34.7,3C165.5,77.1,165.4,75.4,165.3,73.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M283.1,75.6c-2.9,0-3,0-5.9,0c-31.7,0-64.8-0.1-94.8-1.5l0.1,3.5c18.2,0.4,55.5,1.3,99.8,1.7L283.1,75.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M460.8,75.3c14-1,27.1-2.2,38.8-3.6l0.4-3.3c-9.2,1.2-31.6,3.8-39.1,4.3L460.8,75.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M290.1,75.5l-1,3.8c18.6,0.1,38.3,0.1,58.3-0.1l-0.5-4.2C328,75.8,309.6,75.3,290.1,75.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M427,74.1c-25,1.1-44.8,0.9-71.8,0.9l0.5,4.1c24.5-0.3,49.2-0.9,72.5-1.9L427,74.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M515.9,70.3c11.6-1.5,21.6-3.1,34.3-4.9l0.6-2.9l-34.5,4.3L515.9,70.3z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "305.2,153.1 304.6,155.7 324.2,155.7 323.7,153.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "213.6,115.8 213.6,118.2 272.8,117.4 273.6,114.3 "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M113.8,168.6L113.8,168.6c-13.7,1.1-25.8-9-26.9-22.6l-0.4-4.3c0,1.1,0,2.2,0,3.2l0.3,3.6 c1.1,13.6,13.2,23.8,26.9,22.6h0c13.2-1.1,23.1-12.1,22.9-25C135.6,157.9,126.1,167.6,113.8,168.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfanLogo);
export default __webpack_public_path__ + "static/media/ufan-logo.85629f7c674ae86266a178bfde9e8b56.svg";
export { ForwardRef as ReactComponent };